import MarketingPage from './views/marketing.page';

MarketingPage.path = '/marketing';

export default {
  views: {
    MarketingPage,
  },
};
